import { defineMessages } from 'react-intl';

const scope = 't.component.PortalTable';

const globalScope = 't.global';

export default defineMessages({
  addColumns: {
    id: `${scope}.addColumns`,
    defaultMessage: 'Colonne aggiuntive',
  },
  confirm: {
    id: `${globalScope}.confirm`,
    defaultMessage: 'Conferma',
  },
  rowsPerPage: {
    id: `${scope}.rowsPerPage`,
    defaultMessage: 'Righe per pagina',
  },
  page: {
    id: `${scope}.page`,
    defaultMessage: 'Pag.',
  },
  ofPage: {
    id: `${scope}.ofPage`,
    defaultMessage: 'di',
  },
  totalElements: {
    id: `${scope}.totalElements`,
    defaultMessage: 'Occorrenze totali:',
  },
});
